// Module
var code = "<div data-visual-type=\"control\" id=\"frame-wrap\">\r\n\t<iframe ng-show=\"vm.loaded\" sandbox=\"allow-same-origin\"></iframe>\r\n\t<div ng-show=\"!vm.loaded\" class=\"mx-loading-bg\"></div>\r\n</div>\r\n";
// Exports
export default code;